import { prefersReducedMotion } from '@theme/utilities';

/**
 * Desplaza ligeramente las imágenes del hero según la posición en el viewport (efecto parallax).
 * No aplica a vídeo. Respeta prefers-reduced-motion (el CSS también lo anula).
 */
function bindHeroParallax(hero) {
  if (!(hero instanceof HTMLElement)) {
    return;
  }
  if (hero.dataset.parallaxBound === 'true') {
    return;
  }
  if (prefersReducedMotion()) {
    return;
  }

  const media = hero.querySelector('.hero__media-wrapper');
  if (!media) {
    return;
  }

  const images = media.querySelectorAll('img.hero__image');
  if (images.length === 0) {
    return;
  }

  hero.dataset.parallaxBound = 'true';

  const intensity = Math.max(10, Math.min(40, Number(hero.dataset.parallaxIntensity) || 25));

  const update = () => {
    const rect = hero.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) {
      for (const img of images) {
        img.style.setProperty('--hero-parallax-y', '0px');
      }
      return;
    }

    const raw = rect.top * 0.15;
    const y = Math.max(-intensity, Math.min(intensity, raw));

    for (const img of images) {
      img.style.setProperty('--hero-parallax-y', `${y}px`);
    }
  };

  let ticking = false;
  const onScrollOrResize = () => {
    if (ticking) {
      return;
    }
    ticking = true;
    requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  };

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);
  update();
}

/**
 * @param {ParentNode} [root]
 */
function init(root = document) {
  for (const hero of root.querySelectorAll('[data-hero-image-parallax]')) {
    bindHeroParallax(hero);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => init());
} else {
  init();
}

document.addEventListener('shopify:section:load', (event) => {
  const target = event.target;
  if (target instanceof HTMLElement) {
    init(target);
  }
});
